export default {"src":"/_next/static/media/Bsky.cdf765a4.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};